import {
  StoryblokComponent,
  storyblokEditable,
  renderRichText,
} from "@storyblok/react";
import { Breadcrumb } from "./Breadcrumb";
import { FooterBuffer } from "./FooterBuffer";

const P2PFundraising = ({ blok }) => {
  return (
    <>
      <div {...storyblokEditable(blok)} className="font-display ">
        <div className="container herosub">
          <Breadcrumb currentName={blok.title} />
          <h1>{blok.title}</h1>
          <h2>{blok.subtitle}</h2>
        </div>

        <div className="font-display text-left p2p-content">
          <div className="intro-p2p">
            <div
              className="introstat"
              dangerouslySetInnerHTML={{
                __html: renderRichText(blok.introstat),
              }}
            />
            <div className="introstat-image">
              <img src={blok.statimage.filename} alt={blok.statimage.alt} />
            </div>
          </div>
          <div className="card-grid">
            {blok.columns
              ? blok.columns.map((blok) => (
                  <StoryblokComponent blok={blok} key={blok._uid} />
                ))
              : null}
          </div>
        </div>
      </div>
      <FooterBuffer />
    </>
  );
};

export default P2PFundraising;
